import React from 'react'
import Profile from './profile'

const Experience = () => {
  return (
    <>
        <Profile/>
        <div className="section" id="experience">
            <div className="container cc-experience">
                <div className="h4 text-center mb-4 title">Work Experience</div>
                <div className="card">
                <div className="row">
                    <div className="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body cc-experience-header">
                        <p>October, 2022 - Present</p>
                        <div className="h5">Universal Innovation Company Limited • Morogoro</div>
                    </div>
                    </div>
                    <div className="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body">
                        <div className="h5">Web Developer</div>
                        <p>
                            <ul>
                                <li>Participated in the gathering of website requirements.</li>
                                <li>Designed and developed the company website to create a more visually appealing, user-friendly experience.</li>
                                <li>Deployed website using NetPoa platform.</li>
                                <li>Performed updates for the website to achieve user's requirements.</li>                                
                            </ul>
                        </p>
                    </div>
                    </div>
                </div>
                </div>
                <div className="card">
                <div className="row">
                    <div className="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body cc-experience-header">
                        <p>May, 2022 - December,2022</p>
                        <div className="h5">SOKOINE UNIVERSITY OF AGRICULTURE</div>
                    </div>
                    </div>
                    <div className="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body">
                        <div className="h5">System Developer</div>
                        <p>
                            <ul>
                                <li>Participated in gathering of system requirements.
                                    Developed SmartTB web-based application that can be used by both health care providers and TB patients in
                                    Tanzania. The SmartTB can register TB patients and monitor their medication adherence.
                                </li>
                                <li>Presented the system to the client on how the system works.</li>
                                <li>Made updates for the comments obtained during the all presentations.</li>
                                <li>
                                    Developed SUA Driving School System by using Laravel PHP framework for back-end and livewire for front-end
                                    which facilitate new student applications and billing issues.
                                </li>
                            </ul>
                        </p>
                    </div>
                    </div>
                </div>
                </div>
                <div className="card">
                <div className="row">
                    <div className="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body cc-experience-header">
                        <p>06,July 2022 - 15,September 2022</p>
                        <div className="h5">NATIONAL BUREAU OF STATISTICS • Mtwara</div>
                    </div>
                    </div>
                    <div className="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
                    <div className="card-body">
                        <div className="h5">Regional IT Supervisor</div>
                        <p>
                            <ul>
                                <li>Trained Regional census supervisors Mtwara region on how to use Tablet and Tanzania census application during data collection.</li>
                                <li>Supervised Regional census supervisors at district level (Masasi) during training provision for district census
                                clerks, census IT supervisors and content supervisors.
                                </li>
                                <li>Participated in troubleshooting Census application (TZCENSUS2022) during data collection.</li>
                                <li>Trained census clerks, census IT supervisors and content supervisors on how to install census application in a Tablet.</li>
                                <li>Trained census clerks, census IT officer on how to receive updates for Tanzania census application from NBS headquarter.</li>
                                <li>Configured Tablet's APN to access the NBS server to submit data collected during Census to the NBS servers.</li>
                                <li>Participated in the data collection during the census.</li>
                            </ul>
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Experience
